'use client';

import {
  SessionProvider as NextAuthSessionProvider,
  useSession,
} from 'next-auth/react';

function SessionGate({ children }: Readonly<{ children: React.ReactNode }>) {
  const { status } = useSession();

  if (status === 'loading') {
    return null;
  }

  return <>{children}</>;
}

export function SessionProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <NextAuthSessionProvider>
      <SessionGate>{children}</SessionGate>
    </NextAuthSessionProvider>
  );
}
